import { CommonLibService, SystemDateService } from '@lib/services';

/**
 * 発券期限内かを判定する
 * @param item
 * @returns
 */
export function isExpiryIssuanceTimeLimit(
  systemDateSvc: SystemDateService,
  issuanceTimeLimit: string | undefined
): boolean {
  if (!!issuanceTimeLimit) {
    const date = systemDateSvc.getSystemDate();
    if (date.toISOString().substring(0, 10).replace(/-/g, '') <= issuanceTimeLimit) {
      return true;
    }
  }
  return false;
}

/**
 * プロパティマスタから値を取得する
 * @param key
 * @returns
 */
export function getMPropertyByKey(_common: CommonLibService, key: string): string {
  return _common.aswMasterService.getMPropertyByKey('servicing', key);
}
